// extracted by mini-css-extract-plugin
export default {"swiper":"index_swiper_GkCk-","swiperItem":"index_swiperItem_xSlKG","chip":"index_chip_YY18b","show":"index_show_H7WSs","ShowOnce":"index_ShowOnce_2DFI3"};